import React, { useState, useEffect } from 'react';
import { supabase } from '../../services/supabase';

const ManageEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: '',
    location: '',
    category: 'service',
    requiresRegistration: false,
  });

  const fetchEvents = async () => {
    const { data, error } = await supabase
      .from('events')
      .select('*')
      .order('date', { ascending: true });
      
    if (!error && data) {
      setEvents(data);
    } else {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error: insertError } = await supabase.from('events').insert([{
        title: formData.title,
        description: formData.description,
        date: new Date(formData.date).toISOString(),
        location: formData.location,
        category: formData.category,
        requiresRegistration: formData.requiresRegistration
      }]);
      
      if (insertError) throw insertError;
      alert('Event Created!');
      setFormData({ title: '', description: '', date: '', location: '', category: 'service', requiresRegistration: false });
      fetchEvents();
    } catch (error) {
      console.error("Error adding document: ", error);
      alert('Failed to create event');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if(window.confirm('Are you sure you want to delete this event?')) {
      await supabase.from('events').delete().eq('id', id);
      fetchEvents();
    }
  };

  return (
    <div className="admin-page">
      <h1>Manage Events</h1>
      <p>Here you will be able to add, edit, and delete church events that appear in the mobile app.</p>
      
      <div className="admin-split-layout">
        <div className="admin-form-card">
          <h3>Create New Event</h3>
          <form onSubmit={handleSubmit} className="admin-form">
            <div className="form-group">
              <label>Title</label>
              <input type="text" name="title" value={formData.title} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Date & Time</label>
              <input type="datetime-local" name="date" value={formData.date} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Location</label>
              <input type="text" name="location" value={formData.location} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Category</label>
              <select name="category" value={formData.category} onChange={handleChange} style={{padding: '0.75rem', borderRadius: '0.375rem', border: '1px solid #d1d5db'}}>
                <option value="service">Service</option>
                <option value="outreach">Outreach</option>
                <option value="youth">Youth</option>
                <option value="womens">Women's</option>
                <option value="mens">Men's</option>
                <option value="special">Special</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea name="description" value={formData.description} onChange={handleChange} required style={{padding: '0.75rem', borderRadius: '0.375rem', border: '1px solid #d1d5db', minHeight: '100px'}} />
            </div>
            <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '0.5rem' }}>
              <input type="checkbox" name="requiresRegistration" checked={formData.requiresRegistration} onChange={handleChange} />
              <label>Requires Registration?</label>
            </div>
            <button type="submit" disabled={loading} className="admin-btn">
              {loading ? 'Creating...' : 'Create Event'}
            </button>
          </form>
        </div>

        <div className="admin-list-card">
          <h3>Current Events</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {events.map(event => (
              <li key={event.id} style={{ background: '#fff', padding: '1rem', marginBottom: '1rem', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h4 style={{ margin: '0 0 0.5rem 0' }}>{event.title}</h4>
                    <p style={{ margin: '0', fontSize: '0.875rem', color: '#6b7280' }}>
                      {new Date(event.date).toLocaleString()} | {event.location}
                    </p>
                  </div>
                  <button onClick={() => handleDelete(event.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontWeight: 'bold' }}>Delete</button>
                </div>
              </li>
            ))}
            {events.length === 0 && <p style={{color: '#6b7280'}}>No events created yet.</p>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ManageEvents;
